import { Component, Fragment, forwardRef } from "react";
import "./invoice.css";
import { CURRENCY, DATEFORMAT } from "../../contants";

const Invoice = forwardRef(
  (
    {
      printData = defaultPrintData,
      restaurant,
      logo,
      gstNumber,
      receiptMessage,
      branchAddress,
      printSetting,
    },
    ref,
  ) => {
    const startDate = printData?.selectedParams?.date?.start
      ? moment(printData?.selectedParams?.date?.start).format(DATEFORMAT)
      : undefined;
    const endDate = printData?.selectedParams?.date?.end
      ? moment(printData?.selectedParams?.date?.end).format(DATEFORMAT)
      : undefined;
    const data = printData.data;

    return (
      <div className="cash-ticket" ref={ref}>
        <div
          style={{ display: "flex", justifyContent: "center", marginTop: 10 }}
        >
          <div className="card p-4" style={{ width: "90%" }}>
            <h3 className="">Cash Report</h3>
            <table className="mt-2">
              <tbody>
                <tr>
                  <th> {logo && <img src={logo} className="logo" />}</th>
                  <th className="text-center">
                    <h4>{restaurant}</h4>
                    {gstNumber && <p>GST -{gstNumber} hello</p>}
                  </th>
                  <th className="text-right">
                    <h4>Report Date</h4>
                    {startDate && (
                      <p>
                        {startDate} {endDate && ` - ${endDate}`}
                      </p>
                    )}
                  </th>
                </tr>
              </tbody>
            </table>
            <div className="divider" />

            <table className="postable table mt-2">
              <thead>
                <tr>
                  <th className="sr">Particulars</th>
                  <th className="quantity">({CURRENCY}) Credit</th>
                  <th className="price">({CURRENCY}) Debit</th>
                </tr>
              </thead>
              <tbody>
                {data.map((d, i) => {
                  return (
                    <tr>
                      {renderItem(d, "particulars", i, "sr")}
                      {renderItem(d, "credit", i, "quantity")}
                      {renderItem(d, "debit", i, "price")}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  },
);

class BillComponent extends Component {
  render() {
    const {
      printData = defaultPrintData,
      restaurant,
      logo,
      gstNumber,
      receiptMessage,
      branchAddress,
      printSetting,
    } = this.props;

    return printData ? (
      <Invoice
        restaurant={restaurant}
        printData={printData}
        logo={logo}
        gstNumber={gstNumber}
        receiptMessage={receiptMessage}
        branchAddress={branchAddress}
        printSetting={printSetting}
      />
    ) : (
      <div className={`invoice-box invoice-box-hide" `}>No Data found</div>
    );
  }
}
export default BillComponent;

const renderItem = (value, variable, index, className) => {
  const par = value[variable].value;
  const isStrong = value[variable].isStrong;
  const isSubtitle = value[variable].isSubtitle;

  return (
    <Fragment key={index}>
      <td
        className={`${className} text-primary font-15 font-weight-normal ${
          isStrong && "font-weight-bold"
        } ${isSubtitle && "pl-4"}`}
      >
        {par}
      </td>
    </Fragment>
  );
};
const defaultPrintData = {
  selectedParams: {
    date: {
      start: "2021-11-30T10:43:14.812Z",
      end: "2021-11-30T10:43:14.812Z",
    },
    role: "restaurantadmin",
    restaurantId: "60db5e21a36fd9343a463a0a",
    reportType: "cashbook",
  },
  data: [
    {
      particulars: {
        value: "Opening Balance",
        isStrong: true,
      },
      credit: {
        value: "757321.01",
        isStrong: true,
      },
      debit: {
        value: "-",
        isStrong: true,
      },
    },
    {
      particulars: {
        value: "Sales",
        isStrong: true,
      },
      credit: {
        value: "900.00",
        isStrong: true,
      },
      debit: {
        value: "-",
        isStrong: true,
      },
    },
    {
      particulars: {
        value: "Cash",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: 900,
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "Card",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "Other",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "Expenses",
        isStrong: true,
      },
      credit: {
        value: "-",
        isStrong: true,
      },
      debit: {
        value: 25000,
        isStrong: true,
      },
    },
    {
      particulars: {
        value: "Milk Products",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "BATI ATO",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "PARCHURAN",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "PAPPU",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "Salary",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 25000,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "Fuel Expenses",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "ROTI ATO",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "DUNGARI & LASAN",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "KUNTAL",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "Vegetables",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "RAMADEV",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "PANIR",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "TEL",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "DAL",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "Rice",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "PAPAD",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "DEDSTOK",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "ANISH",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "AVAK",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "Electricity Bills",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "KARIYANU",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "DUKAN BHADU",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "DISPOSEBAL",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "VC",
        isStrong: false,
        isSubtitle: true,
      },
      credit: {
        value: "-",
        isStrong: false,
        isSubtitle: true,
      },
      debit: {
        value: 0,
        isStrong: false,
        isSubtitle: true,
      },
    },
    {
      particulars: {
        value: "Closing Balance",
        isStrong: true,
      },
      credit: {
        value: "-",
        isStrong: true,
      },
      debit: {
        value: 733221.01,
        isStrong: true,
      },
    },
    {
      particulars: {
        value: "Balance",
        isStrong: true,
      },
      credit: {
        value: 758221.01,
        isStrong: true,
      },
      debit: {
        value: 758221.01,
        isStrong: true,
      },
    },
  ],
};
